import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { Briefcase, FileText, User, Heart, LayoutDashboard, Home } from "lucide-react";

const navItems = {
  APPLIER: [
    { to: "/applier/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/jobs", label: "Jobs", icon: Briefcase },
    { to: "/applier/dashboard?tab=saved", label: "Saved", icon: Heart },
    { to: "/applier/applications", label: "Apps", icon: FileText },
    { to: "/profile", label: "Profile", icon: User },
  ],
  RECRUITER: [
    { to: "/recruiter/dashboard", label: "Home", icon: Home },
    { to: "/jobs", label: "Jobs", icon: Briefcase },
    { to: "/recruiter/post-job", label: "Post", icon: Briefcase },
    { to: "/recruiter/applications", label: "Apps", icon: FileText },
    { to: "/recruiter/profile", label: "Profile", icon: User },
  ],
  ADMIN: [
    { to: "/admin/dashboard", label: "Home", icon: Home },
    { to: "/admin/users", label: "Users", icon: User },
    { to: "/admin/jobs", label: "Jobs", icon: Briefcase },
    { to: "/admin/post-job", label: "Post", icon: FileText },
  ],
};

export default function BottomNav() {
  const { user, role } = useAuth();
  const location = useLocation();

  if (!user) return null;
  const userRole = (role || user.role)?.toUpperCase();
  const items = navItems[userRole] || [];

  const isActive = (to) => {
    const [path, query] = to.split("?");
    if (query) {
      const params = new URLSearchParams(query);
      const current = new URLSearchParams(location.search);
      if (location.pathname !== path) return false;
      for (const [key, value] of params.entries()) {
        if (current.get(key) !== value) return false;
      }
      return true;
    }
    if (path === "/applier/dashboard") {
      return location.pathname === path && !location.search.includes("tab=saved");
    }
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card/90 backdrop-blur-lg border-t border-border shadow-lg z-50 md:hidden safe-area-pb">
      <div className="flex justify-around items-center h-14">
        {items.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.to);

          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center justify-center flex-1 h-full min-w-0 px-1 transition-colors ${
                active ? "text-primary" : "text-muted-foreground"
              }`}
            >
              <Icon className={`w-5 h-5 shrink-0 ${active ? "stroke-[2.5px]" : ""}`} />
              <span className="text-[10px] mt-0.5 font-medium truncate max-w-full">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
